import { render, staticRenderFns } from "./WonderTopicTable.vue?vue&type=template&id=375e9aa2&scoped=true"
import script from "./WonderTopicTable.vue?vue&type=script&lang=js"
export * from "./WonderTopicTable.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicTable.vue?vue&type=style&index=0&id=375e9aa2&prod&scoped=true&lang=css"
import style1 from "./WonderTopicTable.vue?vue&type=style&index=1&id=375e9aa2&prod&lang=css"
import style2 from "./WonderTopicTable.vue?vue&type=style&index=2&id=375e9aa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e9aa2",
  null
  
)

export default component.exports